import { render, staticRenderFns } from "./order-article-select.vue?vue&type=template&id=2ba11bb7&scoped=true&lang=pug&"
import script from "./order-article-select.vue?vue&type=script&lang=js&"
export * from "./order-article-select.vue?vue&type=script&lang=js&"
import style0 from "./order-article-select.vue?vue&type=style&index=0&id=2ba11bb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba11bb7",
  null
  
)

export default component.exports